import axios from "axios";

const proxyPath = window.locationsMadeSuperConfig.proxyPath;

export default function trackEvent(name, properties = {}) {
  axios
    .post(`${proxyPath}/track_event`, {
      name: name,
      sid: findOrSetSID(),
      properties: properties,
    })
    .catch(console.error);

  function findOrSetSID() {
    const currentSID = localStorage.getItem("locationsSID");
    if (currentSID) return currentSID;
    const newSid = generateRandAlphaNumStr(20);
    localStorage.setItem("locationsSID", newSid);
    return newSid;
  }

  function generateRandAlphaNumStr(len) {
    var rdmString = "";
    for (
      ;
      rdmString.length < len;
      rdmString += Math.random().toString(36).substr(2)
    );
    return rdmString.substr(0, len);
  }
}
